import axios from "axios";

const API = axios.create({
  // baseURL: "http://localhost:8000/api",
  baseURL: "http://127.0.0.1:5001/zamar-audit/us-central1/api/api"
  // baseURL: "https://api-pwwaibv65q-uc.a.run.app/api",
});

// Attach token to headers for every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


export default API;
